export default __webpack_public_path__ + "static/media/blm_mamba.86a611c5.png";